/* 
@example

    export const ACTION_NAME = "ACTION_NAME"
*/

/*

  @Authentications/User
*/

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOAD_USER_PROFILE = "LOAD_USER_PROFILE";

/*

 @Admin

*/

// @Notifications
export const LOAD_NOTIFICATION_COUNT = "LOAD_NOTIFICATION_COUNT";
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";

// - dashboard count
export const LOAD_DASHBOARD_COUNT = "LOAD_DASHBOARD_COUNT";

// - @LabX Orders
export const LOAD_LABX_ORDERS = "LOAD_LABX_ORDERS";

// - @ussd Orders
export const LOAD_USSD_ORDERS = "LOAD_USSD_ORDERS";

// - @Call Orders
export const LOAD_CALL_ORDERS = "LOAD_CALL_ORDERS";

// - @Boat Orders
export const LOAD_BOAT_ORDERS = "LOAD_BOAT_ORDERS";

// - @Ongoing Orders
export const LOAD_ONGOING_ORDERS = "LOAD_ONGOING_ORDERS";

// - @Override Orders
export const LOAD_OVERRIDE_ORDERS = "LOAD_OVERRIDE_ORDERS";

// - @Cylinder Orders
export const LOAD_CYLINDER_ORDERS = "LOAD_CYLINDER_ORDERS";

// - @Cancelled Orders
export const LOAD_CANCELLED_ORDERS = "LOAD_CANCELLED_ORDERS";

// - @Overdue Orders
export const LOAD_OVERDUE_ORDERS = "LOAD_OVERDUE_ORDERS";

// - @completed Orders
export const LOAD_COMPLETED_ORDERS = "LOAD_COMPLETED_ORDERS";

// - @Hospital Lists
export const LOAD_HOSPITAL_LIST = "LOAD_HOSPITAL_LIST";

// - @Dispatch List
export const LOAD_DISPATCH_LIST = "LOAD_DISPATCH_LIST";

// - @Lab List
export const LOAD_LAB_LIST = "LOAD_LAB_LIST";

// - @Oxygen list
export const LOAD_OXYGEN_LIST = "LOAD_OXYGEN_LIST";

// @NEW ORDER DETAILS
export const SAVE_ORDER_TYPE = "SAVE_ORDER_TYPE";

export const SAVE_AGENT_TYPE = "SAVE_AGENT_TYPE";

export const SAVE_HOSPITAL_DETAILS = "SAVE_HOSPITAL_DETAILS";

export const SAVE_REQUEST_TYPE = "SAVE_REQUEST_TYPE";

export const SAVE_BLOOD_COMPONENT = "SAVE_BLOOD_COMPONENT";

export const SAVE_BLOOD_GROUP = "SAVE_BLOOD_GROUP";

export const SAVE_GENOTYPE = "SAVE_GENOTYPE";

export const SAVE_ORDER_INFO = "SAVE_ORDER_INFO";

export const BOAT_ORDER = "BOAT_ORDER";
export const NOTIFICATION = "NOTIFICATION";

export const SAVE_ORDER_QUANTITY = "SAVE_ORDER_QUANTITY";

export const SAVE_PAYMENT_METHOD = "SAVE_PAYMENT_METHOD";

export const SAVE_ORDER_REASON = "SAVE_ORDER_REASON";

export const SAVE_CYLINDER_SIZE = "SAVE_CYLINDER_SIZE";

export const SAVE_OXYGEN_TYPE = "SAVE_OXYGEN_TYPE";

export const SAVE_PATIENT_NAME = "SAVE_PATIENT_NAME";

export const SAVE_STOCKBANK_DETAILS = "SAVE_STOCKBANK_DETAILS";

export const CLOSE_ORDER = "CLOSE_ORDER";

export const RETURN_ORDER = "RETURN_ORDER";

export const PROCESS_ORDER = "PROCESS_ORDER";

export const TICKET = "TICKET";

export const FETCH_PRODUCTS = "FETCH_PRODUCTS";

export const TRACK_ORDER = "TRACK_ORDER";

export const ORDER_PRICE = "ORDER_PRICE";

export const PLACE_ORDER = "PLACE_ORDER";

export const LOAD_RIDERS = "LOAD_RIDERS";

export const EXISTING_ORDER = "EXISTING_ORDER";

export const NOTIFICATIONS = "NOTIFICATIONS";

export const COMPLETE_NOTIFICATION = "COMPLETE_NOTIFICATION";

export const NOTIFY_DISPATCH = "NOTIFY_DISPATCH";

export const RIDERS = "RIDERS";

export const VIEW_NOTIFICATION = "VIEW_NOTIFICATION";

export const STOCKBANK_PRODUCTS = "STOCKBANK_PRODUCTS";

export const FETCH_HOSPITALS = "FETCH_HOSPITALS";

export const FETCH_PIPELINES = "FETCH_PIPELINES";

export const FETCH_VENDORS = "FETCH_VENDORS";

export const FETCH_AGENTS = "FETCH_AGENTS";

export const ADD_AGENT = "ADD_AGENT";

export const ADD_DISPATCH = "ADD_DISPATCH";

export const ENABLE_AGENT = "ENABLE_AGENT";

export const DISABLE_AGENT = "DISABLE_AGENT";

export const PREMIUM_LIST = "PREMIUM_LIST";

export const RIDER_DETAILS = "RIDER_DETAILS";

export const CYLINDER_DETAILS = "CYLINDER_DETAILS";

export const CYLINDER_LIST = "CYLINDER_LIST";

export const CYLINDER_SERIES = "CYLINDER_SERIES";

export const CYLINDER_SIZE = "CYLINDER_SIZE";

export const PLANTS_LIST = "PLANTS_LIST";

export const UPDATE_ORDER = "UPDATE_ORDER";

export const NERVE_CLAIMS = "NERVE_CLAIMS";

export const NERVE_SEND_CLAIMS = "SEND_CLAIMS";

export const CRADLE_REQUEST = "CRADLE_REQUEST";

export const CRADLE_UPDATE = "CRADLE_UPDATE";

export const INCIDENT_REPORT = "INCIDENT_REPORT";

export const INCIDENT_REPORT_POST = "INCIDENT_REPORT_POST";

export const NOTIFY_NERVE = "NOTIFY_NERVE";

export const NOTIFY_NERVE_POST = "NOTIFY_NERVE_POST";

export const DELETE_NERVE_POST = "DELETE_NERVE_POST";

export const SHOW_ALL_PO = "SHOW_ALL_PO";

export const CREATE_COHORTS = "CREATE_COHORTS";

export const DELETE_COHORT = "CREATE_COHORT";

export const SHOW_COHORT = "SHOW_COHORT";

export const SHOW_COHORT_LIST = "SHOW_COHORT_LIST";

export const SEND_BULK_MESSAGE = "SEND_BULK_MESSAGE";

export const ADD_HOSPITALS_COHORT = "ADD_HOSPITAL_TO_COHORT";

export const GET_HOSPITAL_CORHOT = "ALL_HOSPITAL_COHORT";

export const GET_ALL_QUOTATION = "GET_ALL_QUOTATION";

export const SINGLE_QUOTATION = "SINGLE_QUOTATION";

export const POST_QUOTATION = "POST_QUOTATION";

export const UPLOAD_INVENTORY = "UPLOAD_INVENTORY";

export const UPDATE_INVENTORY = "UPDATE_INVENTORY";
